// Added by Sejune Oh on 2020-06-29
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
  ClickAwayListener as MaterialUIClickAwayListener,
  ClickAwayListenerProps as MaterialUIClickAwayListenerProps
} from '@material-ui/core'

export const ClickAwayListener: FC<MaterialUIClickAwayListenerProps> = ({ ...props }) => {
  return <MaterialUIClickAwayListener {...props}></MaterialUIClickAwayListener>
}
